import { trpc } from "@/trpc/client";

const getNotification = async (variables) => {
  const limit = Number(variables?.limit) || 20;
  const offset = Number(variables?.offset) || 0;
  const result = await trpc.admin.notifications.list.query({ limit, offset });
  return result.rows ?? result.items ?? result ?? [];
};

const readNotification = async (content) => {
  const notificationId = Number(
    content?.notification_id ?? content?.content?.notification_id,
  );
  const result = await trpc.admin.notifications.markRead.mutate({
    notification_id: notificationId,
  });
  return result?.data ?? result;
};

const countNotification = async () => {
  const result = await trpc.admin.notifications.list.query({ limit: 100, offset: 0 });
  const rows = result.rows ?? result.items ?? [];
  const unread = Array.isArray(rows)
    ? rows.filter((row) => !(row.notification_readings && row.notification_readings.length)).length
    : 0;
  return { count: unread };
};

export { getNotification, readNotification, countNotification };
